import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AuthProvider, useAuth } from "@/lib/auth";
import { I18nProvider } from "@/lib/i18n";
import { Toaster } from "@/components/ui/sonner";

import Landing from "@/pages/Landing";
import RegisterYouth from "@/pages/RegisterYouth";
import RegisterSuccess from "@/pages/RegisterSuccess";
import Login from "@/pages/Login";
import AuthCallback from "@/pages/AuthCallback";
import Dashboard from "@/pages/Dashboard";
import YouthList from "@/pages/YouthList";
import Villages from "@/pages/Villages";
import ImportExport from "@/pages/ImportExport";
import Officers from "@/pages/Officers";
import ProgressPage from "@/pages/ProgressPage";
import PublicStats from "@/pages/PublicStats";
import Courses from "@/pages/Courses";
import Heatmap from "@/pages/Heatmap";
import BankLinkage from "@/pages/BankLinkage";
import AdminLayout from "@/components/AdminLayout";

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-paper">
        <div className="font-heading text-lg text-[#1E3A8A] animate-pulse">Loading…</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function AppRouter() {
  const location = useLocation();
  // Synchronous detection of session_id BEFORE any other route
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/register" element={<RegisterYouth />} />
      <Route path="/register/success/:regNo" element={<RegisterSuccess />} />
      <Route path="/stats" element={<PublicStats />} />
      <Route path="/courses" element={<Courses />} />
      <Route path="/login" element={<Login />} />
      <Route element={<ProtectedRoute><AdminLayout /></ProtectedRoute>}>
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/youth" element={<YouthList />} />
        <Route path="/villages" element={<Villages />} />
        <Route path="/officers" element={<Officers />} />
        <Route path="/progress" element={<ProgressPage />} />
        <Route path="/heatmap" element={<Heatmap />} />
        <Route path="/bank" element={<BankLinkage />} />
        <Route path="/data-tools" element={<ImportExport />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <I18nProvider>
            <AppRouter />
            <Toaster richColors position="top-right" />
          </I18nProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
